import React, { useEffect, useRef, useState } from "react";
import "./home.css";


import {
  House,
  Hammer,
  CirclePlus,
  Building2,
  ShoppingCart,
  Phone,
  MessageCircle,
  Mail
} from "lucide-react";


import ProfileMenu from "./Profile/ProfileMenu";
import PostModal from "./Modals/PostModal";
import ProductSuggestionRow from "./Feed/ProductSuggestionRow";
import ProfessionSuggestionRow from "./Feed/ProfessionSuggestionRow";
import { useNavigate, useLocation } from "react-router-dom";
import CommentsModal from "./Modals/CommentsModal";
import FeedMenuPopup from "./Feed/FeedMenuPopup";
import logo from "../../assets/logo.png";
import API from "../../api";
import BottomNavigation from "../common/BottomNavigation";
import ProfileEditModal from "./Profile/ProfileEditModal";
import WorkSuggestionRow from "./Feed/WorkSuggestionRow";
import Search from "./Search";
import CustomerMenuModal from "./Modals/CustomerMenuModal";

export default function Home() {

  
  const navigate = useNavigate();

  /* ================= USER ================= */
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("civilink_user")) || null;
    } catch {
      return null;
    }
  });

  /* ================= FEED ================= */
  const [feed, setFeed] = useState([]);

  const addToFeed = (newPost) => {
    setFeed((prev) => [
      { ...newPost, id: Date.now() },
      ...prev,
    ]);
  };


  /* ================= MODALS ================= */
  const [showPostModal, setShowPostModal] = useState(false);
  const [showCustomerMenu, setShowCustomerMenu] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [showProfessionMenu, setShowProfessionMenu] = useState(false);

  const [showConsult, setShowConsult] = useState(false);
  const [consultUser, setConsultUser] = useState(null);

  const [showComments, setShowComments] = useState(false);
  const [activePost, setActivePost] = useState(null);
  const [showProfileEdit, setShowProfileEdit] = useState(false);
  

  /* ================= POST MENU ================= */
  const [menuPost, setMenuPost] = useState(null);
  const menuRef = useRef(null);

  /* ================= SAVED POSTS ================= */
const [savedPosts, setSavedPosts] = useState([]);
const [hiddenPosts, setHiddenPosts] = useState([]);


useEffect(() => {
  const loadHiddenPosts = async () => {
    if (!localStorage.getItem("token")) return;

    try {
      const res = await API.get("/users/me");

      if (res.data.success) {
        setHiddenPosts(res.data.user.hiddenPosts || []);
      }
    } catch (err) {
      console.error("Failed to load hidden posts", err);
    }
  };

  loadHiddenPosts();
}, []);

useEffect(() => {
  const loadSavedPosts = async () => {
    if (!localStorage.getItem("token")) return;

    try {
      const res = await API.get("/users/saved-posts");

      if (res.data.success) {
        setSavedPosts(res.data.posts.map(p => p._id));
      }
    } catch (err) {
      console.error("Failed to load saved posts", err);
    }
  };

  loadSavedPosts();
}, []);


  useEffect(() => {
    const handleClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuPost(null);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  /* ================= LOAD PENDING POST ================= */
  useEffect(() => {
    const pending = localStorage.getItem("civilink_new_post");
    if (pending) {
      addToFeed(JSON.parse(pending));
      localStorage.removeItem("civilink_new_post");
    }
  }, []);

  useEffect(() => {
  if (sessionStorage.getItem("civilink_open_post")) {
    sessionStorage.removeItem("civilink_open_post");
    setShowPostModal(true);
  }

  if (sessionStorage.getItem("civilink_open_customer")) {
    sessionStorage.removeItem("civilink_open_customer");
    setShowCustomerMenu(true);
  }
}, []);

  /* ================= LOAD HOME FEED ================= */
useEffect(() => {
  const loadFeed = async () => {
    try {
      const res = await fetch("/api/feed/home");
      const data = await res.json();

      if (data.success) {
        // IMPORTANT: use backend _id as id
        const normalized = data.feed.map(item => ({
          ...item,
          id: item._id
        }));
        setFeed(normalized);
      }
    } catch (err) {
      console.error("Failed to load feed", err);
    }
  };

  loadFeed();
}, []);

useEffect(() => {
  if (!user) return;

  if (
    user.authProvider === "google" &&
    (!user.phone || user.phone.trim() === "")
  ) {
    setShowProfileEdit(true);
  }
}, [user]);


  /* ================= PROFESSION SELECT ================= */
  const handleProfessionSelect = (profession) => {
    if (!user) {
  navigate("/");
  return;
}

    if (user.isProfessional) {
      alert("Profession already finalized");
      return;
    }

    const updatedUser = {
      ...user,
      profession,
      isProfessional: true,
    };

    localStorage.setItem("civilink_user", JSON.stringify(updatedUser));
    setUser(updatedUser);
    setShowProfessionMenu(false);

    window.location.href = "/profile";
  };

  /* ================= LOGOUT ================= */
  const handleLogout = async () => {
  try {
    await API.post("/auth/logout");
  } catch (err) {
    console.error("Logout failed", err);
  }

  localStorage.removeItem("civilink_user");
  localStorage.removeItem("token");
  localStorage.removeItem("role");

  window.location.replace("/");
};

  const openContactProfessional = (professional) => {
  if (!localStorage.getItem("token")) {
    navigate("/");
    return;
  }

  setConsultUser(professional);
  setShowConsult(true);
};



const handleLike = async (post) => {
  const user = JSON.parse(localStorage.getItem("civilink_user"));

  if (!user) {
  navigate("/");
  return;
}

  try {
    const res = await API.post(`/feed/${post._id}/like`);

    if (!res.data.success) return;

    setFeed(prev =>
      prev.map(p =>
        p._id === res.data.postId
          ? { ...p, likes: res.data.likes }
          : p
      )
    );
  } catch (err) {
    console.error("Like failed", err);
  }
};

const handleAddComment = async (text) => {
  if (!localStorage.getItem("token")) {
  navigate("/");
  return;
}

  try {
    const res = await API.post(
      `/feed/${activePost._id}/comment`,
      { text }
    );

    if (!res.data.success) return;

    setFeed(prev =>
      prev.map(p =>
        p._id === activePost._id
          ? { ...p, comments: res.data.comments }
          : p
      )
    );

    setActivePost(prev => ({
      ...prev,
      comments: res.data.comments
    }));
  } catch (err) {
    console.error("Comment failed", err);
  }
};
/* ================= REPORT POST ================= */
const handleReportPost = async (post) => {
  if (!localStorage.getItem("token")) {
  navigate("/");
  return;
}

  try {
    await API.post("/feedback", {
      message: `
POST REPORT

Post ID: ${post._id}
Reported User: ${post.user?.name || "Unknown"}
Post Type: ${post.type || "feed"}
Content:
${post.text || post.title || "N/A"}
      `,
      source: "post_report"
    });

    alert("Post reported successfully");
  } catch (err) {
    console.error("Report failed", err);
    alert("Failed to report post");
  }
};

const sharePostDirect = async (post) => {
  const postUrl = `${window.location.origin}/post/${post._id}`;

  try {
    if (navigator.share) {
      await navigator.share({
        title: "Civilink Post",
        url: postUrl
      });
    } else {
      await navigator.clipboard.writeText(postUrl);
      alert("Post link copied");
    }
  } catch (err) {
    console.error("Share failed", err);
  }
};

/* ================= SAVE POST ================= */
const handleSavePost = async (postId) => {
  if (!localStorage.getItem("token")) {
  navigate("/");
  return;
}

  try {
    const res = await API.put(`/post/save/${postId}`);

    if (!res.data.success) return;

    setSavedPosts(prev =>
      prev.includes(postId)
        ? prev.filter(id => id !== postId)
        : [...prev, postId]
    );
  } catch (err) {
    console.error("Save post failed", err);
  }
};

const handleHidePost = async (post) => {
  if (!localStorage.getItem("token")) {
  navigate("/");
  return;
}

  try {
    await API.put(`/post/hide/${post._id}`);

    setHiddenPosts(prev =>
      prev.includes(post._id)
        ? prev
        : [...prev, post._id]
    );
  } catch (err) {
    console.error("Hide post failed", err);
  }
};

const formatTime = (date) => {
  const diff = Math.floor((Date.now() - new Date(date)) / 1000);

  if (diff < 60) return "Just now";
  if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} hr ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)} day ago`;

  return new Date(date).toLocaleDateString();
};


  /* ================= RENDER ================= */
  return (
    <div className="home-container">

      {/* ================= TOP BAR ================= */}
      <header className="home-header">
       <div className="home-logo">
  <img src={logo} alt="Civilink Logo" />
</div>
<Search
  user={user}
  navigate={navigate}
  onConsult={openContactProfessional}
/>
       <div
  className="top-profile"
  onClick={() => {
  if (!localStorage.getItem("token")) {
    navigate("/");
    return;
  }

  setShowProfileMenu(true);
}}
>
  {user?.profilePhoto ? (
    <img
      src={user.profilePhoto}
      alt={user.name}
      className="top-profile-img"
    />
  ) : (
    <span className="top-profile-text">
      {(user?.name || "U").charAt(0).toUpperCase()}
    </span>
  )}
</div>

      </header>

      {/* ================= FEED ================= */}
      <main className="home-feed">
 
  
      {/* 🔽 EXISTING FEED CODE GOES HERE (UNCHANGED) */}

        {feed.length ? (
          feed.filter(item => !hiddenPosts.includes(item._id))
              .map((item, index) => {

   const city =
  item.location && item.location.city
    ? item.location.city
    : item.user && item.user.location
    ? item.user.location.city
    : "";

const state =
  item.location && item.location.state
    ? item.location.state
    : "";

    

    return (
      <React.Fragment key={item.id}>
           

              <article
                className="feed-card"
                onClick={() => setMenuPost(null)}
              >
                {/* HEADER */}
                <div className="feed-header">
                <div
  className="feed-user-box"
  onClick={() => {
  if (!localStorage.getItem("token")) {
    navigate("/");
    return;
  }

  if (item.user?._id) {
    navigate(`/profile/${item.user._id}`);
  }
}}
  style={{ cursor: "pointer" }}
>
<div className="feed-avatar">
  {item.user?.profilePhoto ? (
    <img
      src={item.user.profilePhoto}
      alt={item.user.name}
    />
  ) : (
    <span>
      {(item.user?.name || "U").charAt(0).toUpperCase()}
    </span>
  )}
</div>

  <div>
    <div className="feed-user">
      {item.user?.name || "Civilink User"}
      <span className="feed-role">
        {item.user?.profession || item.role || "Member"}
      </span>
    </div>
                      <div className="feed-meta">
  📍 {city}{state ? `, ${state}` : ""} • {formatTime(item.createdAt)}
</div>

                    </div>
                  </div>

                  <button
                    className="feed-menu"
                    onClick={(e) => {
                      e.stopPropagation();
                      setMenuPost(menuPost?.id === item.id ? null : item);
                    }}
                  >
                    ⋮
                  </button>
                </div>

                {/* IMAGE */}
                {item.imageUrl && (
                  <img src={item.imageUrl} alt="post" className="feed-image" />
                )}

                {/* CONTENT */}
                <div className="feed-content">

                  {/* BADGE */}
  {item.type === "sell" && (
    <span className="badge sell">For Sale</span>
  )}
  {item.type === "rent" && (
    <span className="badge rent">To-Let</span>
  )}

                  {item.title && <h4>{item.title}</h4>}
                  {typeof item.text === "string" && <p>{item.text}</p>}

                 {item.price && (
  <div className="feed-price">
    {typeof item.price === "object"
      ? `${item.price.amount ?? item.price.price ?? ""}`
      : item.price}
  </div>
)}

                </div>

                {/* ACTIONS */}
                <div className="feed-actions">
  <button
    className={`feed-action-btn ${
      item.likes?.includes(
        JSON.parse(localStorage.getItem("civilink_user"))?._id
      )
        ? "liked"
        : ""
    }`}
    onClick={(e) => {
      e.stopPropagation();   // 🔑 VERY IMPORTANT
      handleLike(item);
    }}
  >
    ❤️ {item.likes?.length || 0}
  </button>


                  <button
  className="feed-action-btn"
  onClick={() => {
    if (!localStorage.getItem("token")) {
      navigate("/");
      return;
    }

    setActivePost(item);
    setShowComments(true);
  }}
>
  💬 Comment
</button>

                  <button
  className="feed-action-btn"
  onClick={(e) => {
    e.stopPropagation(); // 🔑 important
    sharePostDirect(item);
  }}
>
  🔗 Share
</button>


                <button
  className="feed-action-btn"
  onClick={(e) => {
    e.stopPropagation();
    openContactProfessional(item.user);
}}
>
  📞 Consult
</button>


                </div>

                {/* MENU */}
                {menuPost?.id === item.id && (
                  <div
                    className="feed-menu-popup"
                    ref={menuRef}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <button
  onClick={() => {
    handleSavePost(item._id);
    setMenuPost(null);
  }}
>
  {savedPosts.includes(item._id)
    ? "⭐ Unsave post"
    : "⭐ Save post"}
</button>

                    <button
  onClick={() => {
  handleHidePost(item);
  setMenuPost(null);
}}
>
  🙈 Hide post
</button>

                   <button
  onClick={() => {
  const confirmed = window.confirm("Report this post?");
  if (!confirmed) return;

  handleReportPost(item);
  setMenuPost(null);
}}
>
  🚩 Report
</button>


                  </div>
                )}
              </article>

              {index % 6 === 2 && (
    <ProductSuggestionRow />
)}

              {/* PROFESSION SUGGESTION */}
               {index % 10 === 2 && (
      <ProfessionSuggestionRow key={`suggestion-${item.id}`} />
    )}

{index % 8 === 4 && (
  <WorkSuggestionRow
    key={`work-suggestion-${item.id}`}
    onConsult={openContactProfessional}
  />
)}

  </React.Fragment>
          );
        })
        ) : (
          <div style={{ padding: 20, color: "#666" }}>
            No feed items yet.
          </div>
        )}
    
</main>

      {/* ================= MODALS ================= */}
      {showPostModal && (
        <PostModal
          onClose={() => setShowPostModal(false)}
          addToFeed={addToFeed}
        />
      )}

      

{showComments && (
  <CommentsModal
    post={activePost}
    onClose={() => {
      setShowComments(false);
      setActivePost(null);
    }}
    onAddComment={handleAddComment}
  />
)}

{/* ================= CUSTOMER MENU ================= */}

{showCustomerMenu && (
  <CustomerMenuModal
    onClose={() => setShowCustomerMenu(false)}
  />
)}
      
    
{showConsult && (
  <div
    className="customer-sheet-overlay"
    onClick={() => setShowConsult(false)}
  >
    <div
      className="customer-sheet"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="sheet-handle" />

      <h3 className="sheet-title">
        Contact Professional
      </h3>

      <p className="sheet-subtitle">
        Choose how you'd like to connect.
      </p>

      {consultUser?.phone && (
  <>
    <button
      className="sheet-btn primary"
      onClick={() => {
        window.location.href = `tel:${consultUser.phone}`;
        setShowConsult(false);
      }}
    >
      <Phone size={18} />
      <span>Call</span>
    </button>

    <button
      className="sheet-btn primary"
      onClick={() => {
        const text = encodeURIComponent(
          `Hello ${consultUser.name},

I found your profile on Civilink and would like to discuss my construction requirements.`
        );

        window.open(
          `https://wa.me/91${consultUser.phone}?text=${text}`,
          "_blank"
        );

        setShowConsult(false);
      }}
    >
      <MessageCircle size={18} />
      <span>WhatsApp</span>
    </button>
  </>
)}

{consultUser?.email && (
  <button
    className="sheet-btn primary"
    onClick={() => {
      window.location.href = `mailto:${consultUser.email}?subject=Construction Inquiry from Civilink`;
      setShowConsult(false);
    }}
  >
    <Mail size={18} />
    <span>Email</span>
  </button>
)}

{!consultUser?.phone && !consultUser?.email && (
  <div className="contact-unavailable">
    Contact information not available.
  </div>
)}

      <button
        className="sheet-btn outline"
        onClick={() => setShowConsult(false)}
      >
        Close
      </button>
    </div>
  </div>
)}



      <ProfileMenu
        open={showProfileMenu}
        onClose={() => setShowProfileMenu(false)}
        user={user}
        onLogout={handleLogout}
      />

      {showProfileEdit && (
  <ProfileEditModal
    user={user}
    isProfessional={user?.isProfessional}
    onClose={() => {}}
    onSave={async (updatedUser) => {
  try {
    const res = await API.put(
      "/users/profile",
      updatedUser
    );

    if (!res.data.success) {
      alert("Failed to save profile");
      return;
    }

    setUser(res.data.user);

    localStorage.setItem(
      "civilink_user",
      JSON.stringify(res.data.user)
    );

    setShowProfileEdit(false);
  } catch (err) {
    console.error(err);
    alert("Server error");
  }
}}
  />
)}

      {/* ================= BOTTOM BAR ================= */}
      <BottomNavigation
  onPost={() => {
  if (!localStorage.getItem("token")) {
    navigate("/");
    return;
  }

  setShowPostModal(true);
}}
  onCustomerMenu={() => {
  if (!localStorage.getItem("token")) {
    navigate("/");
    return;
  }

  setShowCustomerMenu(prev => !prev);
}}
/>
    </div>
  );
}